"use client";

import { ArrowUpRight, Diamond, Sparkles, Utensils, Anchor } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function RevenueServices() {
  const heading = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const grid = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const footer = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.3
  });
  const services = [{
    numeral: "I",
    title: "OTA Revenue Management",
    description: "Expert optimization of your online travel agency listings. We leverage data-driven insights to increase visibility, improve conversion rates, and maximize your property's revenue potential across all major platforms.",
    icon: Diamond,
    href: "/OTARevenueManagementListingsPage"
  }, {
    numeral: "II",
    title: "Hospitality Tech Implementation",
    description: "Strategic selection and seamless integration of modern hospitality tech stacks. We ensure your systems communicate effectively to streamline operations and enhance the guest experience from booking to checkout.",
    icon: Sparkles,
    href: "/ServicePage"
  }, {
    numeral: "III",
    title: "Revenue Audits",
    description: "Comprehensive performance reviews of your current revenue strategies. We identify untapped opportunities, analyze market demand, and provide actionable recommendations to drive sustainable growth for your hotel.",
    icon: Utensils,
    href: "/RevenueManagementConsultingPage"
  }, {
    numeral: "IV",
    title: "Digital Marketing Strategy",
    description: "Tailored digital marketing campaigns designed to capture direct bookings. From SEO to paid media, we build a robust online presence that positions your hotel as the preferred choice in your local market.",
    icon: Anchor,
    href: "/HotelSEODigitalMarketingServicesPage"
  }];
  return <section data-section-id="3728" id="strategicperformancemarketing" className="bg-background text-foreground py-24 md:py-32 px-6 md:px-12 overflow-hidden">
      <div className="mx-auto max-w-7xl">
        {}
        <div ref={heading.ref} className={`flex flex-col items-center text-center transition-all duration-1000 ease-out ${heading.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <span className="font-mono text-xs uppercase tracking-[0.4em] text-primary mb-8">
            Our Expertise
          </span>
          <h2 className="font-serif font-default text-4xl md:text-5xl lg:text-[56px] leading-[1.1] text-foreground max-w-3xl">
            Four pillars
            <br className="hidden md:block" />
            <span className="italic text-secondary"> of revenue growth.</span>
          </h2>
          <div className="mt-12 h-px w-24 bg-border" />
        </div>

        {}
        <div ref={grid.ref} className={`mt-20 md:mt-24 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 border-t border-border transition-all duration-1000 ease-out ${grid.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {services.map((service, i) => {
          const Icon = service.icon;
          return <div key={i} data-index={i} className="group relative p-10 md:p-12 border-b border-border md:border-b-0 md:border-r last:border-r-0 md:[&:nth-child(2)]:border-r-0 lg:[&:nth-child(2)]:border-r lg:last:border-r-0 transition-colors duration-700 hover:bg-accent/40">
                {}
                <div className="font-serif italic text-secondary text-4xl md:text-[40px] leading-none mb-10">
                  {service.numeral}
                </div>

                {}
                <div className="mb-10">
                  <Icon className="size-12 text-secondary stroke-[0.75] transition-all duration-700 ease-out group-hover:rotate-[4deg] group-hover:text-primary" strokeWidth={0.75} />
                </div>

                {}
                <h3 className="font-serif font-default text-2xl text-foreground mb-5 leading-tight">
                  {service.title}
                </h3>

                {}
                <p className="font-sans text-sm text-muted-foreground leading-[1.7] mb-10">
                  {service.description}
                </p>

                {}
                <Link to={service.href} className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.3em] text-foreground hover:text-secondary transition-colors duration-500">
                  <span>Learn More</span>
                  <ArrowUpRight className="size-3.5 transition-transform duration-500 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </Link>

                {}
                <span className="hidden md:block absolute top-0 right-0 h-full w-px bg-secondary opacity-0 group-hover:opacity-100 transition-opacity duration-700 pointer-events-none" />
              </div>;
        })}
        </div>

        {}
        <div ref={footer.ref} className={`mt-20 md:mt-28 flex flex-col items-center text-center transition-all duration-1000 ease-out ${footer.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="h-px w-16 bg-border mb-10" />
          <p className="font-serif italic text-lg md:text-xl text-muted-foreground max-w-xl">
            Ready to optimize your hotel's performance? Let's talk.
          </p>
        </div>
      </div>
    </section>;
}